var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconFomManifest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 8.04933 10.8827 9.72667 9.70533 10.93C9.11701 11.5246 8.47519 12.0638 7.788 12.5407L7.504 12.734L7.37067 12.8227L7.11933 12.9827L6.89533 13.1193L6.618 13.2807C6.42967 13.3879 6.2167 13.4442 6 13.4442C5.7833 13.4442 5.57033 13.3879 5.382 13.2807L5.10467 13.1193L4.758 12.906L4.63 12.8227L4.35667 12.6407C3.61532 12.1389 2.92471 11.5659 2.29467 10.93C1.11733 9.72533 0 8.04933 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM6 4C5.73736 4 5.47728 4.05173 5.23463 4.15224C4.99198 4.25275 4.7715 4.40007 4.58579 4.58579C4.40007 4.7715 4.25275 4.99198 4.15224 5.23463C4.05173 5.47728 4 5.73736 4 6C4 6.26264 4.05173 6.52272 4.15224 6.76537C4.25275 7.00802 4.40007 7.2285 4.58579 7.41421C4.7715 7.59993 4.99198 7.74725 5.23463 7.84776C5.47728 7.94827 5.73736 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6C8 5.46957 7.78929 4.96086 7.41421 4.58579C7.03914 4.21071 6.53043 4 6 4Z",
    fill: "#52BD70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconFomManifest);
export default __webpack_public_path__ + "static/media/LocationIconFomManifest.40185670225b7646c43c3d6cc48f218b.svg";
export { ForwardRef as ReactComponent };